export default __webpack_public_path__ + "static/media/STAR_TINY.af8b016a.svg";